import type { LoginInfo } from "~/models/dto";

import { request } from "../generic/request";

import { type UseQueryOptions, type UseQueryResult, useQuery } from "./react-query";

export const useQueryLoginInfo = <TResult = LoginInfo>(
	options?: UseQueryOptions<LoginInfo, Error, TResult>,
): UseQueryResult<TResult, Error> => useQuery("loginInfo", () => request<LoginInfo>("/loginInfo"), options);
